(ns iris.login.events
  (:require
   [re-frame.core :as re-frame]
   [iris.events :as events]
   [ajax.core :as ajax]
   [iris.utils :as utils]
   [iris.localstorage :as localstorage]
   [day8.re-frame.async-flow-fx :as async-flow-fx]
   [iris.routes :as routes]
   [clojure.string :as str]
   [iris.cookie :as cookie]
   [goog.crypt.base64 :as b64]
   [iris.globals :as globals]
   [iris.firebase :as firebase]
   [iris.sessionstorage :as sessionstorage]
   [iris.data.api :as data]
   [iris.tags.events :as tags-events]
   [iris.worker-pool :as worker-pool]
   [iris.auth.api :as auth]))

(re-frame/reg-event-db
 ::set-login-error-message
 (fn [db [_ msg]]
   (assoc-in db [:login :error-message] msg)))

(re-frame/reg-event-db
 ::login-reset-needed
 (fn [db [_ val]]
   (println "SHOULD BE SETTING LOGGIN RESEST NEEDED")
   (assoc-in db [:login :reset-needed] val)))


(defn get-jwt-cookie []
  (or
   (cookie/get-cookie globals/AUT_JWT_COOKIE_NAME)
   (cookie/get-cookie globals/JWT_COOKIE_NAME)))


(defn get-fbjwt-cookie []
  (when-let [fbjwt (cookie/get-cookie globals/FBJWT_COOKIE_NAME)]
    (b64/decodeString fbjwt)))


;; cookie versions
;; (defn get-jwt []
;;   (cookie/get-cookie "jwt"))


;; (defn get-fbjwt []
;;   (when-let [fbjwt (cookie/get-cookie "fbjwt")]
;;     (b64/decodeString fbjwt)))


;; cookie version
;; (defn get-login_redirect []
;;   (or (cookie/get-cookie "login_redirect") "/new/posts"))

;; (defn get-login_redirect []
;;   (or @globals/login_redirect "/posts"))


(defn get-login_redirect []
  (if (or (empty? @globals/login_redirect) (= @globals/login_redirect "/login"))
    "/posts"
    @globals/login_redirect))



;; (defn get-login_redirect
;;   ([] (get-login_redirect {:remove false}))
;;   ([options]
;;    (println "get-login_redirect here with options" options)
;;    (if-let [path (cookie/get-cookie "login_redirect")]
;;                (do
;;                  (when (true? (:remove options))
;;                    (cookie/remove-cookie "login_redirect"))
;;                  path)
;;                "/new/posts")))

(defn get-jwt-payload [jwt]
  (js->clj (.parse js/JSON (b64/decodeString (second (str/split jwt #"\.")))) :keywordize-keys true))


(defn get-exp-time-left [exp]
  (let [now (/ (.now js/Date) 1000)]
    (int (- exp now))))


(defn jwt-valid?
  "Pure function — returns a tagged keyword, no side effects.
   :valid      — token is good
   :expired    — token has expired
   :no-access  — token is alive but user lacks iris privilege
   nil         — jwt is empty/nil"
  [jwt]
  (when-not (empty? jwt)
    (let [payload  (get-jwt-payload jwt)
          alive?   (> (get-exp-time-left (:exp payload)) 0)
          access?  (some #(= % "iris") (:adminuis payload))]
      (cond
        (and access? alive?) :valid
        (not access?)        :no-access
        (not alive?)         :expired))))


(defn fbjwt-valid? [jwt]
  (when-not (empty? jwt)
    (let [payload (get-jwt-payload jwt)
          exptl (get-exp-time-left (:exp payload))]
      (> exptl 0))))


;; cookie versions
;; (defn fbjwt-logged-in? []
;;   (when-let [fbjwt (get-fbjwt)]
;;     (when (fbjwt-valid? fbjwt)
;;       fbjwt)))


;; (defn jwt-logged-in? []
;;   (when-let [jwt (get-jwt)]
;;     (when (jwt-valid? jwt)
;;       jwt)))

;; TODO: if logged out, firebase instance should be cleaned up

;; WORKS! non cookie version
;; (defn fbjwt-logged-in? []
;;   (when-let [fbjwt @globals/fbjwt]
;;     (when (fbjwt-valid? fbjwt)
;;       fbjwt)))

;; WORKS! non cookie version
;; (defn jwt-logged-in? []
;;   (when-let [jwt @globals/jwt]
;;     (when (jwt-valid? jwt)
;;       jwt)))


(defn fbjwt-logged-in? []
  (if-let [fbjwt @globals/fbjwt]
    (when (fbjwt-valid? fbjwt)
      fbjwt)
    (when-let [fbjwt (get-fbjwt-cookie)]
      (when (fbjwt-valid? fbjwt)
        (reset! globals/fbjwt fbjwt)
        (reset! globals/fbjwt-payload (get-jwt-payload fbjwt))
        fbjwt))))

(defn jwt-logged-in? []
  (if-let [jwt (or @globals/jwt (get-jwt-cookie))]
    (let [result (jwt-valid? jwt)]
      (when (= result :valid)
        ;; Hydrate globals from cookie if atom was empty
        (when (nil? @globals/jwt)
          (reset! globals/jwt jwt)
          (let [jwt-payload (get-jwt-payload jwt)]
            (reset! globals/jwt-payload jwt-payload)
            (re-frame/dispatch [::events/set-jwt-payload jwt-payload])))
        jwt))
    nil))




(defn logged-in? []
  (when-let [jwt (jwt-logged-in?)]
    (when-not (fbjwt-logged-in?)
      (re-frame/dispatch [::get-firebase-jwt jwt]))
    true))


(defn linger? []
  (or @globals/linger
      (when-let [jwt (get-jwt-cookie)]
        (when (= :valid (jwt-valid? jwt))
          (reset! globals/linger true)
          true))))


;; (re-frame/reg-fx
;;  :set-js-global-jwt
;;  (fn [val]
;;    (set! js/jwt val)))


;; (re-frame/reg-fx
;;  :set-js-global-firebase-jwt
;;  (fn [val]
;;    (set! js/firebaseJwt val)))



(re-frame/reg-fx
 :set-globals-linger
 (fn [val]
   (reset! globals/linger val)))

(re-frame/reg-fx
 :set-globals-jwt
 (fn [val]
   (reset! globals/jwt val)))

(re-frame/reg-fx
 :set-globals-fbjwt
 (fn [val]
   (reset! globals/fbjwt val)))

(re-frame/reg-fx
 :set-globals-login_redirect
 (fn [val]
   (reset! globals/login_redirect val)))

(re-frame/reg-fx
 :set-globals-jwt-payload
 (fn [val]
   (reset! globals/jwt-payload val)))

(re-frame/reg-fx
 :set-globals-fbjwt-payload
 (fn [val]
   (reset! globals/fbjwt-payload val)))

;; Cookie version
;; (re-frame/reg-event-fx
;;  ::get-jwt-success
;;  (fn [{:keys [db]} [_ data]]
;;    (if-not (empty? data)
;;      (let [payload (get-jwt-payload data)
;;            exptl (get-exp-time-left (:exp payload))]
;;        {:cookie/remove {:name "jwt"}
;;         :cookie/set {:name "jwt"
;;                      :value data
;;                      :max-age exptl
;;                      :path "/"}
;;         :set-js-global-jwt data
;;         :db (assoc-in db [:login :message] nil)})
;;      {})))




(re-frame/reg-fx
 :set-jwt-cookie
 (fn [data]
  ;;  (if (true? @globals/linger)
   (if (linger?)
     (let [payload (get-jwt-payload data)
           exptl (get-exp-time-left (:exp payload))]
       (cookie/remove-cookie globals/JWT_COOKIE_NAME "/")
       (cookie/set-cookie globals/JWT_COOKIE_NAME data exptl "/"))
     (cookie/remove-cookie globals/JWT_COOKIE_NAME "/"))))





;; cookie version
;; (re-frame/reg-event-fx
;;  ::get-firebase-jwt-success
;;  (fn [{:keys [db]} [_ data]]
;;    (if-not (empty? data)
;;      (let [payload (get-jwt-payload data)
;;            exptl (get-exp-time-left (:exp payload))]
;;        {:cookie/remove {:name "fbjwt"}
;;         :cookie/set {:name "fbjwt"
;;                      :value (b64/encodeString data)
;;                      :max-age exptl
;;                      :path "/"}
;;         :set-js-global-firebase-jwt data})
;;      {})))


(re-frame/reg-fx
 :set-fbjwt-cookie
 (fn [data]
  ;;  (if (true? @globals/linger)
   (if (linger?)
     (let [payload (get-jwt-payload data)
           exptl (get-exp-time-left (:exp payload))]
       (cookie/remove-cookie globals/FBJWT_COOKIE_NAME "/")
       (cookie/set-cookie globals/FBJWT_COOKIE_NAME (b64/encodeString data) exptl "/"))
     (cookie/remove-cookie globals/FBJWT_COOKIE_NAME "/"))))

(def session-refresh-message
  "Your session needs to be refreshed. Please log in again.")


(re-frame/reg-event-fx
 ::get-firebase-jwt-success
 (fn [{:keys [db]} [_ data]]
   (if-let [fbjwt (not-empty (get-in data [:result :data]))]
     {:set-globals-fbjwt fbjwt
      :set-globals-fbjwt-payload (get-jwt-payload fbjwt)
      :set-fbjwt-cookie fbjwt
      :db (-> db
              (assoc-in [:login :error-message] nil)
              (assoc-in [:loading] false))}
     {:db (assoc-in db [:loading] false)
      :dispatch [::logout {:message session-refresh-message}]})))

(re-frame/reg-event-db
 ::get-firebase-jwt-failure
 (fn [db]
   (-> db
       (assoc-in [:login :error-message] "Get FBJWT failure!")
       (assoc-in [:loading] false))))


;; (re-frame/reg-event-fx
;;  ::get-firebase-jwt
;;  (fn [{:keys [db]} [_ jwt]]
;;    {:http-xhrio {:method :get
;;                  :uri (str (utils/get-service-url "apollo") "/firebase-jwt")
;;                  :timeout 8000
;;                  :headers [:Authorization (str "Bearer " jwt)]
;;                  :response-format (ajax/text-response-format)
;;                  :on-success      [::get-firebase-jwt-success]
;;                  :on-failure      [::get-firebase-jwt-failure]}
;;     :db (-> db
;;             (assoc-in [:loading] true))}))

(re-frame/reg-event-fx
 ::get-firebase-jwt
 (fn [{:keys [db]} [_ jwt]]
   {:http-xhrio (events/track-http-xhrio
                 "FirebaseToken.Get"
                 {:method :post
                  ;;  :uri (str (utils/get-service-url "aut") "/rpc")
                  ;;  :uri js/autURL
                  :uri js/hermesURL
                  :body (utils/clj->json
                         {:jsonrpc "2.0"
                          :id 0
                          ;;  :method "getFirebaseToken"
                          :method "FirebaseToken.Get"})
                  :timeout 60000
                  :headers [:Authorization (str "Bearer " jwt)]
                  :response-format (ajax/json-response-format {:keywords? true})
                  :on-success      [::get-firebase-jwt-success]
                  :on-failure      [::get-firebase-jwt-failure]})
    :db (-> db
            (assoc-in [:loading] true))}))



(re-frame/reg-event-fx
 ::login-redirect
 (fn [e [_]]
   (let [path (get-login_redirect)]
     (re-frame/dispatch [::events/route-to path])
    ;;  {:cookie/remove {:name "login_redirect"}}
     {:set-globals-login_redirect nil})))



;; URL: aut.rkdev.org/rpc
;; Login methods: "getToken", "getTokenAndClaims"
;; Change password method: "changePassword"

;; changePassword data fields: username, oldPassword, newPassword
;; getToken, getTokenAndClaims fields: username, password



(re-frame/reg-event-fx
 ::get-token-and-claims-success
 (fn [{:keys [db]} [_ res]]
   (if-let [error-message (get-in res [:error :message])]
     {:db (-> db
              (assoc-in [:login :error-message] error-message)
              (assoc-in [:login :success-message] nil)
              (assoc-in [:loading] false))}
     (let [token (get-in res [:result :data :token])]
       (when-not (empty? token)
       (let [jwt-payload (get-jwt-payload token)]
         {:set-globals-jwt token
          :set-globals-jwt-payload jwt-payload
          :set-jwt-cookie token
          ;; Added the right way to dispatch the add-msg event from effects map but realized that it would duplicate the message since it's being added in core.cljs under jwt-observer. Anyways, keeping it below. 
          ;; :dispatch [::events/add-msg {:info (str "Logged in Iris, env "
          ;;                                         (:env jwt-payload)
          ;;                                         ", tier " js/window.tier
          ;;                                         ", as " (:uid jwt-payload))}]
          :db (-> db
                  (assoc-in [:jwt-payload] jwt-payload)
                  (assoc-in [:login :error-message] nil)
                  (assoc-in [:login :success-message] nil)
                  (assoc-in [:loading] false))}))))))



;; NOTE: started using the actual error message from backend so the messages are not hardcoded here
;; (defn get-token-and-claims-failure-message [error-code]
;;   (cond (= error-code -32011)
;;         "Login failed: user must change password first!"
;;         (= error-code -32010)
;;         "Login failure!"))

(re-frame/reg-event-db
 ::get-token-and-claims-failure
 (fn [db [_ res]]
   (println "res" res)
   (let [curr-error-message (get-in db [:login :error-message])
         new-error-message (or (get-in res [:error :message])
                               (get-in res [:response :error :message])
                               "Login failed.")]
     (-> db
         (assoc-in [:login :error-message] (str/join " " (remove str/blank? [curr-error-message new-error-message])))
         (assoc-in [:login :success-message] nil)
         (assoc-in [:loading] false)))))


(re-frame/reg-event-fx
 ::get-token-and-claims
 (fn [{:keys [db]} [_ username password]]
    {:http-xhrio (events/track-http-xhrio
                  "getToken"
                  {:method :post
                   ;; :uri (str (utils/get-service-url "aut") "/rpc")
                   :uri js/autURL
                   :body (utils/clj->json
                          {:jsonrpc "2.0"
                           :id 0
                           ;; :method "getTokenAndClaims"
                           :method "getToken"
                           :params {:options {:debug false}
                                    :data {:username username :password password}}})
                   :timeout 60000
                   :headers {;;  "Authorization" (str "Bearer " jwt)
                             "Content-Type" "application/json; charset=UTF-8"}
                   :response-format (ajax/json-response-format {:keywords? true})
                   :on-success [::get-token-and-claims-success]
                   :on-failure [::get-token-and-claims-failure]})
     :db (-> db
             (assoc-in [:loading] true))}))






(re-frame/reg-event-fx
 ::change-password-success
 (fn [{:keys [db]} [_ res]]


   (if-let [error-message (get-in res [:error :message])]
     {:db (-> db
              (assoc-in [:login :error-message] error-message)
              (assoc-in [:loading] false))}
     {:db (-> db
              (assoc-in [:login :reset-needed] false)
              (assoc-in [:login :error-message] nil)
              (assoc-in [:login :success-message] "Password changed successfully!")
              (assoc-in [:loading] false))})


  ;;  (if (true? (get-in res [:result :data :success]))
  ;;    {:db (-> db
  ;;             (assoc-in [:login :reset-needed] false)
  ;;             (assoc-in [:login :error-message] nil)
  ;;             (assoc-in [:login :success-message] "Password changed successfully!")
  ;;             (assoc-in [:loading] false))}
  ;;    {})
   ))


(re-frame/reg-event-db
 ::change-password-failure
 (fn [db [_ res]]
   (let [error-code (get-in res [:response :error :code])
         error-message (get-in res [:response :error :message])]
     (-> db
         (assoc-in [:login :error-message] error-message)
         (assoc-in [:loading] false)))))


(re-frame/reg-event-fx
 ::change-password
 (fn [{:keys [db]} [_ username old-password new-password]]
   {:http-xhrio (events/track-http-xhrio
                 "changePassword"
                 {:method :post
                  ;;  :uri (str (utils/get-service-url "aut") "/rpc")
                  :uri js/autURL
                  :body (utils/clj->json
                         {:jsonrpc "2.0"
                          :id 0
                          :method "changePassword"
                          :params {:options {:debug false}
                                   :data {:username username
                                          :oldPassword old-password
                                          :newPassword new-password}}})
                  :timeout 60000
                  :headers {;;  "Authorization" (str "Bearer " jwt)
                            "Content-Type" "application/json; charset=UTF-8"}
                  :response-format (ajax/json-response-format {:keywords? true})
                  :on-success [::change-password-success]
                  :on-failure [::change-password-failure]})
    :db (-> db
            (assoc-in [:loading] true))}))


(defn login-flow
  [username password]
  {:first-dispatch [::get-token-and-claims username password]
   :rules [{:when :seen?
            :events ::get-token-and-claims-failure
            :dispatch-fn (fn [[e res]]
                           (let [error-code (get-in res [:error :code])]
                             (when (= error-code 22)
                               [[::login-reset-needed true]])))}
           {:when :seen?
            :events ::get-token-and-claims-success
            :dispatch-fn (fn [[e res]]
                           (let [error-code (get-in res [:error :code])
                                 jwt (get-in res [:result :data :token])
                                 result (jwt-valid? jwt)
                                 tier (when jwt (:env (get-jwt-payload jwt)))]
                             (cond
                               (= error-code 22) [[::login-reset-needed true]]
                               error-code nil
                               (= result :valid) [[::get-firebase-jwt jwt]]
                               (= result :no-access) [[::set-login-error-message (str "You do not have access to Iris (" tier "). Please contact your administrator.")]]
                               (= result :expired) [[::set-login-error-message "Your login session has expired. Please log in again."]]
                               :else [[::get-token-and-claims-failure res]])))}
           {:when :seen?
            :events ::get-token-and-claims-failure
            :halt? true}
           {:when :seen?
            :events ::get-firebase-jwt-success
            :dispatch-fn (fn [[_ res]]
                           (when (not-empty (get-in res [:result :data]))
                             [[::login-redirect]]))
            :halt? true}]})


(re-frame/reg-event-fx
 ::login
 (fn [e [_ username password linger]]
   {:set-globals-linger linger
    :async-flow (login-flow username password)}))


(re-frame/reg-event-fx
 ::reset-password
 (fn [e [_ username password new-password new-password-2]]
   {}))


;; ============================================================================
;; Auth lifecycle effects — pure re-frame fx
;; ============================================================================

(re-frame/reg-fx
 :clear-auth-cookies
 (fn [_]
   (cookie/remove-base-domain-cookie globals/AUT_JWT_COOKIE_NAME "/")
   (cookie/remove-cookie globals/JWT_COOKIE_NAME "/")
   (cookie/remove-cookie globals/FBJWT_COOKIE_NAME "/")))

(re-frame/reg-fx
 :clear-auth-atoms
 (fn [_]
   (reset! globals/jwt nil)
   (reset! globals/fbjwt nil)
   (reset! globals/jwt-payload nil)
   (reset! globals/fbjwt-payload nil)
   (reset! globals/fb-user nil)))

(re-frame/reg-fx
 :auth/sign-out
 (fn [_]
   (auth/sign-out!)))

;; ============================================================================
;; Logout — single canonical handler
;; ============================================================================

(re-frame/reg-event-fx
 ::logout
 (fn [{:keys [db]} [_ {:keys [message]}]]
   {:db (-> db
            (assoc-in [:auth :logged-in?] false)
            (cond-> message (assoc-in [:login :error-message] message)))
    :fx [[:dispatch [::events/set-fb-auth-state nil]]
         [:clear-auth-cookies nil]
         [:clear-auth-atoms nil]
         [:auth/sign-out nil]]}))

(defn logout
  "Programmatic logout. Prefer this over dispatching [::logout] directly.
   opts - optional map, e.g. {:message \"Session expired.\"}"
  ([] (re-frame/dispatch [::logout]))
  ([opts] (re-frame/dispatch [::logout opts])))

;; ============================================================================
;; Auth state in db
;; ============================================================================

(re-frame/reg-event-db
 ::set-auth-logged-in
 (fn [db [_ val]]
   (assoc-in db [:auth :logged-in?] val)))

;; ============================================================================
;; WS sync — moved here from core.cljs to avoid circular deps
;; ============================================================================

(defn- async-default-ws-from-firebase []
  (println "async-default-ws-from-firebase")
  (auth/wait-for-user-with-timeout
   5000
   (fn [user]
     (if user
       (do
         (js/console.log "User signed in:" (.-uid user))
         (.then (data/get-default-ws-with-fallback (first (:websites @globals/jwt-payload)))
                (fn [ws]
                  (js/console.log "Retrieved value:" ws)
                  (sessionstorage/set-item! "iris.defaults.ws" ws)
                  (re-frame/dispatch [::events/set-ws-sync ws]))))
       (do
         (js/console.warn "No user after 5s – continuing unauthenticated.")
         (let [ws (first (:websites @globals/jwt-payload))]
           (sessionstorage/set-item! "iris.defaults.ws" ws)
           (re-frame/dispatch [::events/set-ws-sync ws]))
         (re-frame/dispatch [::events/add-msg {:debug-message "Firebase auth timeout – sync skipped"}])
         (auth/on-auth-ready #(re-frame/dispatch [::events/add-msg {:info "Firebase auth ready"}])))))))

(defn sync-default-ws []
  (println "sync-default-ws")
  (if-let [ws (sessionstorage/get-item "iris.defaults.ws")]
    (re-frame/dispatch [::events/set-ws-sync ws])
    (async-default-ws-from-firebase)))

;; ============================================================================
;; Atom watcher event handlers — thin dispatchers in core.cljs call these
;; ============================================================================

(re-frame/reg-event-fx
 ::fbjwt-changed
 (fn [{:keys [db]} [_ _old-val new-val]]
   (when (and new-val (not (auth/authenticated?)))
     (auth/on-fbjwt-available! new-val)
     (worker-pool/init!)
     (sync-default-ws))
   nil))

(re-frame/reg-event-fx
 ::jwt-changed
 (fn [{:keys [db]} [_ old-val new-val]]
   (cond
     ;; JWT set — validate and act
     (some? new-val)
     (case (jwt-valid? new-val)
       :valid
       (let [{:keys [uid env]} (get-jwt-payload new-val)
             tier js/window.tier]
         {:db (assoc-in db [:auth :logged-in?] true)
          :fx (cond-> [[:dispatch [::events/add-msg {:info (str "Logged in Iris, env " env ", tier " tier ", as " uid)}]]
                       [:dispatch [::tags-events/load-autotags-list new-val "TLO"]]]
                ;; First login only — not JWT renewal. Renewal keeps the existing WS connection.
                (nil? old-val) (conj [:dispatch [::on-jwt-available]]))})
       :expired
       {:dispatch [::logout {:message "Your session has expired. Please log in again."}]}
       :no-access
       {:dispatch [::logout {:message "You do not have access to Iris. Please contact your administrator."}]}
       nil)

     ;; JWT cleared — auth/sign-out! handles Firebase + WebSocket teardown.
     ;; Cleanup of cookies/atoms already done by ::logout before this fires.
     (and old-val (nil? new-val))
     {:fx [[:auth/sign-out nil]]})))

(re-frame/reg-event-fx
 ::on-jwt-available
 (fn [_ _]
   (auth/on-jwt-available!)
   nil))

;; ============================================================================

(re-frame/reg-event-fx
 ::check-auth
 (fn [{:keys [db]} _]
   "Runs once at startup. Validates any JWT found in atom or cookie,
    sets [:auth :logged-in?] in db, and triggers logout with a message
    if the token is expired or lacking privileges."
   (let [raw-jwt (or @globals/jwt (get-jwt-cookie))]
     (if (nil? raw-jwt)
       {:db (assoc-in db [:auth :logged-in?] false)}
       (case (jwt-valid? raw-jwt)
         :valid
         ;; jwt-logged-in? hydrates atoms from cookie if needed
         (let [jwt (jwt-logged-in?)]
           (merge
            {:db (assoc-in db [:auth :logged-in?] true)}
            (when-not (fbjwt-logged-in?)
              {:dispatch [::get-firebase-jwt jwt]})))
         :expired
         {:dispatch [::logout {:message "Your session has expired. Please log in again."}]}
         :no-access
         (let [tier (:env (get-jwt-payload raw-jwt))]
           {:dispatch [::logout {:message (str "You do not have access to Iris (" tier "). Please contact your administrator.")}]})
         {:db (assoc-in db [:auth :logged-in?] false)})))))
